import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "issue-show" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import PageTitleBar from '@/components/PageTitleBar.vue'
import { issueStore } from '@/stores/issue'
import IssueShowDetailsCard from '@/views/issue/cards/IssueShowDetailsCard.vue'
import IssueShowAddCommentCard from '@/views/issue/cards/IssueShowAddCommentCard.vue'
import IssueShowCommentsCard from '@/views/issue/cards/IssueShowCommentsCard.vue'
import IssueShowAssignedToCard from '@/views/issue/cards/IssueShowAssignedToCard.vue'
import IssueShowSolvedAndDeniedButtons from '@/components/issue/IssueShowSolvedAndDeniedButtons.vue'
import IssueShowContactDetailsCard from '@/views/issue/cards/IssueShowContactDetailsCard.vue'
import IssueShowBuildingDetailsCard from '@/views/issue/cards/IssueShowBuildingDetailsCard.vue'
import { closedIssueStates, IssueStates } from '@/helpers/issueStates'
import IssueShowTagsCard from '@/views/issue/cards/IssueShowTagsCard.vue'
import IssueAppointmentCard from '@/views/issue/cards/IssueAppointmentCard.vue'
import { authStore } from '@/stores/auth'
import IssueConceptEditCard from '@/views/issue/cards/IssueConceptEditCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShow',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const issueConceptEditCard = ref<InstanceType<typeof IssueConceptEditCard> | null>(null)

onMounted(() => {
  issueStore().getIssue(route.params.issueId.toString())
})

onBeforeUnmount(() => {
  issueStore().issue = null
})

const canEdit = computed(() => {
  return !!(!authStore().user.roleNames.includes('external_inspector') || (authStore().user.roleNames.includes('external_inspector') && issueStore().issue.created_by.id === authStore().user.id))
})

const isConcept = computed(() => {
  return issueStore().issue?.status === IssueStates.Concept
})

const canSaveConcept = computed(() => {
  return issueConceptEditCard.value?.canSave || false
})

const conceptSaving = computed(() => {
  return issueConceptEditCard.value?.saving || false
})

function saveConcept () : void {
  if (issueConceptEditCard.value) {
    issueConceptEditCard.value.saveConcept()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Servicemelding " + _toDisplayString(_unref(issueStore)().issue ? `#${_unref(issueStore)().issue.id}` : ` - Aan het laden..`), 1)
      ]),
      subtitle: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(issueStore)().issue ? _unref(issueStore)().issue.title : ''), 1)
      ]),
      buttons: _withCtx(() => [
        (_unref(issueStore)().issue && !_unref(isConcept) && !_unref(closedIssueStates).includes(_unref(issueStore)().issue.status) && _unref(canEdit))
          ? (_openBlock(), _createBlock(IssueShowSolvedAndDeniedButtons, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Issues' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        }),
        (_unref(issueStore)().issue && _unref(isConcept))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              loading: _unref(conceptSaving),
              disabled: !_unref(canSaveConcept) || _unref(conceptSaving),
              onClick: saveConcept
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Opslaan ")
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [16, 16] }, {
      default: _withCtx(() => [
        (!_unref(issueStore)().issue || _unref(isConcept))
          ? (_openBlock(), _createBlock(IssueConceptEditCard, {
              key: 0,
              ref_key: "issueConceptEditCard",
              ref: issueConceptEditCard
            }, null, 512))
          : (_openBlock(), _createBlock(_component_a_col, {
              key: 1,
              xs: {span: 24},
              sm: {span: 24},
              md: {span: 24},
              lg: {span: 16}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(IssueShowDetailsCard)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_unref(issueStore)().issue && !_unref(closedIssueStates).includes(_unref(issueStore)().issue.status) && _unref(canEdit))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(IssueShowAddCommentCard)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(issueStore)().issue)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(IssueShowCommentsCard)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })),
        (!_unref(isConcept))
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 2,
              xs: {span: 24},
              sm: {span: 24},
              md: {span: 24},
              lg: {span: 8}
            }, {
              default: _withCtx(() => [
                (_unref(issueStore)().issue)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(IssueShowAssignedToCard)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(issueStore)().issue)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(IssueAppointmentCard)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(issueStore)().issue && (_unref(issueStore)().issue.contact_name || _unref(issueStore)().issue.contact_email || _unref(issueStore)().issue.contact_phone))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(IssueShowContactDetailsCard)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(issueStore)().issue?.building)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(IssueShowBuildingDetailsCard)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(issueStore)().issue?.taggedImages?.length)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(IssueShowTagsCard)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})